<template>
  <div class="page__sidebar h-100">
    <component
      :is="sideBar"
      :store="store"
      :counters="allCounters"
      :options="options"
      :selected-option="selectedOption"
      :disable-add-filter="disableAddFilter"
      :custom-options="customOptions"
      @expand="expand"
      @contract="contract"
      @update:selected-option="changeSelectedOption"
      @click-add-filter="$emit('click-add-filter')"
      @remove-option="showRemoveModal"
      @rename-option="showRenameModal"
      @update-option="showUpdateModal"
    />
    <modal-confirmation
      id="studyRequestSideBarConfirmationModal"
      ref="confirmationModal"
    />
    <rename-custom-filter-modal
      id="renameCustomFilterModal"
      ref="renameModal"
      @ok="renameCustomOption"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import store from '@/modules/clinicalModule/components/SideBar/sideBarStore'
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import RenameCustomFilterModal from '@/components/customFilter/RenameCustomFilterModal'
import { getSideBarOptions } from './sideBarOptions'

export default {
    name: 'SideBar',
    components: {
        ModalConfirmation,
        RenameCustomFilterModal
    },
    props: {
        counters: { type: Object } // a map containing the numbers for each badge
    },
    data() {
        return {
            customOptionSelected: null,
            store: store,
            state: store.state
        }
    },
    computed: {
        sideBar() {
            return this.state.sideBar
        },
        customOptions() {
            return this.state.customOptions
        },
        options() {
            return getSideBarOptions()
        },
        selectedOption() {
            return this.state.selectedOption
        },
        disableAddFilter() {
            return this.gridRouteName !== this.$route.name
        },
        gridRouteName() {
            return this.state.gridRouteName
        },
        cardIndexRouteName() {
            return this.state.cardIndexRouteName
        },
        allCounters() {
            return this.counters
        }
    },
    methods: {
        showUpdateModal(option) {
            this.$refs.confirmationModal.ask(() => {
                this.$emit('update-option', option)
            })
        },
        changeSelectedOption(value) {
            store.setSelectedOption(value)
            if (![this.gridRouteName, this.cardIndexRouteName].includes(this.$route.name)) {
                this.$router.push({ name: this.gridRouteName })
            }
            this.$emit('changed-option', value)
        },
        selectDefaultOption() {
            store.selectDefaultOption()
            this.$emit('changed-option', this.state.selectedOption)
        },
        showRemoveModal(option) {
            this.customOptionSelected = option
            this.$refs.confirmationModal.ask(() => {
                store.removeCustomOption(this.customOptionSelected)
                this.showToastSuccessGlobal(this.$t('global.filterDeleted'))
            })
        },
        showRenameModal(option) {
            this.$refs.renameModal.show(option)
        },
        renameCustomOption(option) {
            store.renameCustomOption(option)
            this.showToastSuccessGlobal(this.$t('global.renamedFilter'))
        },
        expand() {
            store.expandSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        contract() {
            store.contractSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        }
    }
}

</script>
